import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-general-10',
  templateUrl: './10.component.html',
  styleUrls: ['./10.component.scss'],
})
export class VbGeneral10Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
